import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {TheRave} from "../TheRave";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {TheRaveReelController} from "../reels/TheRaveReelController";
import {ReelState} from "../../core/reel/ReelState";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {TheRaveEnhancerReelController} from "../reels/TheRaveEnhancerReelController";
import {TheRaveGameConfig} from "../TheRaveGameConfig";

export class TheRaveNormalResultPresentation implements FlowStatePresentation {
    protected _reelStopOrder: number[] = [0, 1, 2, 3, 4]; // reelId[]
    protected _defaultSpinDuration: number = 2.0;

    constructor() {
    }

    public start(flowStateController: FlowStateController): void {
        flowStateController.setSkipCallback(() => this.skip());
        TheRave.reelStopPresentations.start().then(res => flowStateController.finish());
        this._defaultSpinDuration = TheRaveGameConfig.reelStopDelay * 4 + TheRave.reels[4].getDefaultStoppingTime();

        const jurPadding: number = TheRave.gameFlowController.calculatePaddingDuration(this._defaultSpinDuration); // 2.4 is default no win duration with 0.04 stepDuration
        this.getReelsStopResult(false, Math.max(jurPadding, 0.01));
    }

    protected getReelsStopResult(quickStop: boolean, delay: number): void {
        let spinStopOffset: number = 0;
        TheRave.reels.forEach((spinReel: TheRaveReelController) => {
            if (spinReel.reelState === ReelState.SPIN) {
                spinStopOffset = Math.max(
                    spinStopOffset,
                    spinReel.getSpinStopOffset());
            }
        });

        this._reelStopOrder.forEach((reelId: number, order: number) => {
            const reel = TheRave.reels[reelId];
            delay += this.getReelStopDelay(reel, quickStop); // This is a rough estimated time, the reel will take the real time when it's stopping.
            reel.tryStop(spinStopOffset, delay, quickStop, () => Logger.logDev(`Reel ${reelId} stopping.`), this._reelStopOrder[order + 1]);
        });
        delay += 0.5;
        TheRave.enhancerReels.forEach((reel: TheRaveEnhancerReelController, reelId: number) => {
            if (TheRave.model.currentParsedData.enhancerReel[reelId]) {
                delay += this.getReelStopDelay(reel, quickStop);
                reel.tryStop(TheRave.model.reels[reelId + 5].concat(), 0, delay + (quickStop ? 0 : 1), quickStop);
            } else {
                reel.tryStop(["X"], 0, 0, true);
            }// This is a rough estimated time, the reel will take the real time when it's stopping.
        });
    }

    protected getReelStopDelay(reel: TheRaveReelController | TheRaveEnhancerReelController, quickStop: boolean): number {
        if (reel.reelState === ReelState.INACTIVE || reel.reelState === ReelState.STOPPING || reel.reelState === ReelState.STOPPED) {
            return 0;
        }

        if (quickStop) {
            return TheRaveGameConfig.reelStopDelayQuickStop;
        }


        if (reel.hasNearWin()) {
            return TheRaveGameConfig.reelStopNearWinSpin;
        }

        if (TheRave.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            return TheRaveGameConfig.reelStopDelayFastSpin;
        }

        return TheRaveGameConfig.reelStopDelay;
    }

    protected skip(): void {
        Logger.logDev("skip result");
        this.getReelsStopResult(true, 0);
        TheRave.reelStopPresentations.skip();
    }


}